import { render } from "./ModulesView.vue?vue&type=template&id=5b181587&scoped=true"
import script from "./ModulesView.vue?vue&type=script&lang=js"
export * from "./ModulesView.vue?vue&type=script&lang=js"

import "./ModulesView.vue?vue&type=style&index=0&id=5b181587&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b181587"]])

export default __exports__